import { render, staticRenderFns } from "./ProductRowSelect.vue?vue&type=template&id=04e1fd08"
import script from "./ProductRowSelect.vue?vue&type=script&lang=js"
export * from "./ProductRowSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports